<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-07-05 18:25:27
 * @LastEditors: yuka
 * @LastEditTime: 2019-08-08 18:01:50
 * @Description: 还款计划
 -->
<template>
  <div>
    <div class="refund-plan-wrapper">
      <template v-if="recordList.length > 0">
        <div v-for="(item, index) in recordList" :key="index" class="repayment-content">
          <div class="top-bar">
            <span>{{ item.period }}期</span
            ><span>应还本息（元）{{ item.interestOfPrincipal }}</span>
          </div>
          <div class="item-row">
            <span class="label">应还日期</span>
            <span class="text">{{ item.date }}</span>
          </div>
          <div class="item-row">
            <span class="label">本金（元）</span>
            <span class="text">{{ item.principal }}</span>
          </div>
          <div class="item-row">
            <span class="label">利息（元）</span>
            <span class="text">{{ item.interests }}</span>
          </div>
          <div class="item-row">
            <span class="label">剩余本金（元）</span>
            <span class="text">{{ item.rest }}</span>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="no-data">暂无数据</div>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: 'repayment-plan',
  data() {
    return {
      recordList: [],
      title: '还款计划'
    };
  },
  created() {
    if (this.$route.params.flag === '1') {
      this.requestPlan();
    } else {
      this.requestNo1Detail();
      return;
    }
  },
  mounted() {
    // this.$eventBus.$emit('listBarTitle', this.title);
  },
  methods: {
    async requestPlan() {
      const res = await this.$http.post('cg/commonRequest', {
        method: 'project.pc.plan',
        projectid: this.$route.params.id
      });
      if (res.code === 200) {
        let totalRest = 0;
        res.data.forEach(item => {
          totalRest += parseFloat(item.principal);
        });
        this.recordList = res.data.map(item => {
          return {
            period: item.period,
            interestOfPrincipal: item.need_money,
            principal: item.principal,
            interests: item.interest,
            rest: parseFloat(
              totalRest - item.principal <= 0 ? 0 : (totalRest -= item.principal)
            ).toFixed(2),
            date: item.need_time.split(' ')[0]
          };
        });
      }
    },
    // 鲸鱼一号
    async requestNo1Detail() {
      const res = await this.$http.post('/cg/commonRequest', {
        method: 'oproject.detail',
        projectid: this.$route.params.id
      });
      if (res.code === 200) {
        const data = res.data;
        this.recordList = data.returnedList.map(item => {
          return {
            period: item.period,
            interestOfPrincipal: item.need_money,
            principal: item.principal,
            interests: item.interest,
            rest: item.surplus_principal,
            date: item.need_time
          };
        });
      }
    }
  }
};
</script>
<style lang="less" scoped>
.refund-plan-wrapper {
  .repayment-content {
    width: 6.9rem;
    // height: 3.2rem;
    background-color: #ffffff;
    border-radius: 0.12rem;
    margin: 0.3rem auto 0;

    .top-bar {
      display: flex;
      color: #333333;
      font-size: 0.28rem;
      line-height: 0.82rem;
      padding: 0 0.3rem;
      box-sizing: border-box;
      justify-content: space-between;
      border-bottom: solid 0.02rem #e8e8e8;
    }
    .item-row {
      padding: 0 0.3rem;
      line-height: 0.58rem;
      font-size: 0.26rem;
      letter-spacing: 0rem;
      color: #333333;
      display: flex;
      justify-content: space-between;
      .label {
        color: #888888;
      }
    }
  }
  .no-data {
    text-align: center;
    line-height: 2rem;
  }
}
</style>
